// Typelizer digest a283eb1106a0c4404d96f613ba0d6268
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from './runtime'
import { buildUrl } from './runtime'

export default {
  /** GET /settings */
  show: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/settings', {}, options),
    method: 'get',
  }),

  /** PATCH /settings */
  update: (options?: RouteOptions): RouteDefinition<'patch'> => ({
    url: buildUrl('/settings', {}, options),
    method: 'patch',
  }),
}
